exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nunito{font-family:nunito,font-sans}.border-b-1{border-bottom-width:1px}.border-l-1{border-left-width:1px}hover\\:border-none:hover{border-style:none}", ""]);

// exports
